import { Table, Button, message, Popconfirm, Switch, Typography } from 'antd';
import { getCaseScoreList, lockJudgesScore } from '@services/Selection';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// import { LeftOutlined } from '@ant-design/icons';
import config from '@config';
import PageHeader from '@components/PageHeader/PageHeader';

import './index.less';
const columns = [
    {
        title: '成果类别',
        dataIndex: 'rewardName',
        align: 'center',
    },
    {
        title: '排名',
        dataIndex: 'caseRank',
        align: 'center',
    },
    {
        title: '实践编号',
        dataIndex: 'caseId',
        align: 'center',
    },
    {
        title: '实践名称',
        dataIndex: 'caseName',
        align: 'center',
    },
    {
        title: '提报单位',
        dataIndex: 'hosName',
        align: 'center',
    },
    {
        title: '实践分数',
        dataIndex: 'finalScore',
        align: 'center',
    },
];

const Lists = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [dataSource, setDataSource] = useState([]);
    const [scoreLocked, setScoreLocked] = useState(false);
    const [lockLoading, setLockLoading] = useState(false);

    useEffect(() => {
        getCaseScoreList({ projectId: params.pid, stageId: params.sid, topicId: params.tid, platformType: 'pc' }).then(res => {
            if (res?.status_code === 200) {
                setDataSource(res?.data?.list || []);
                setScoreLocked(!!res?.data?.lockedJudgesScore);
            }
        });
    }, [params.pid, params.sid, params.tid]);

    useEffect(() => {
        document.title = '核对结果-医评议';
    }, []);

    const handleReleaseClick = () => {
        // message.success("敬请期待！");
        window.open(`${config.SELECTION_DOMAIN}/rank/cases?projectId=${params.pid}&stageId=${params.sid}&topicId=${params.tid}`);
    };

    /** 确认锁定/解锁评委评分 */
    const handleLockConfirm = () => {
        const nextLocked = !scoreLocked;
        setLockLoading(true);
        lockJudgesScore({
            stageId: Number(params.sid),
            topicId: Number(params.tid),
            state: nextLocked,
        })
            .then(res => {
                if (res?.status_code === 200) {
                    setScoreLocked(nextLocked);
                    message.success(nextLocked ? '评委评分已锁定' : '评委评分已解锁');
                }
            })
            .finally(() => {
                setLockLoading(false);
            });
    };

    return (
        <>
            <PageHeader breadcrumb={[]} className="scoring-setting">
                <span className="back" onClick={() => navigate(-1)}>
                    <i className="bi bi-chevron-left"></i>
                </span>
                <div className="current-title">核对结果</div>
            </PageHeader>

            <div className="page-route-body list-table-content">
                <div className="list-table-toolbar">
                    <Button onClick={handleReleaseClick} type="primary" className="release-rank-button">
                        投屏结果
                    </Button>

                    <div className="score-lock-control">
                        <Typography.Text className="score-lock-label">锁定评委评分</Typography.Text>
                        <Popconfirm title={scoreLocked ? '确认解锁评委评分？' : '确认锁定评委评分？'} description={scoreLocked ? '解锁后评委可继续修改评分，请谨慎操作！' : '锁定后评委将无法修改评分，请谨慎操作！'} okText="确认" cancelText="取消" onConfirm={handleLockConfirm}>
                            <Switch checked={scoreLocked} loading={lockLoading} checkedChildren={<i className="bi bi-lock" />} unCheckedChildren={<i className="bi bi-unlock" />} />
                        </Popconfirm>
                        <Typography.Text className={scoreLocked ? 'score-lock-status-locked' : 'score-lock-status-unlocked'}>{scoreLocked ? '已锁定' : '未锁定'}</Typography.Text>
                    </div>
                </div>
                <Table dataSource={dataSource} columns={columns} rowKey="caseId" pagination={false} />
            </div>
        </>
    );
};

export default Lists;
